import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { Address } from '@quorum/models/xs-resource';
import { map } from 'rxjs/operators';
import {
  AddressEntityActionTypes,
  CreateAddressOnServer,
  CreateAddressOnServerSuccess,
  GetAddressFromServer,
  GetAddressFromServerSuccess,
  UpdateAddressOnServer,
  UpdateAddressOnServerSuccess,
} from './addresses.actions';

@Injectable()
export class AddressEntityEffects {
  
  getAddressFromServer = createEffect(() => this.dataPersistence.fetch(AddressEntityActionTypes.GetAddressFromServer, {
    run: (action: GetAddressFromServer, state: any) => {
      return this.apiService
        .get<Address>(
          `v/1/associates/associates/${action.payload.params.associateId}/addresses/${action.payload.params.sequence}`,
          {
            params: action.payload.params,
          }
        )
        .pipe(
          map((address) => {
            return new GetAddressFromServerSuccess(address);
          })
        );
    },
    onError: (action: GetAddressFromServer, error) => {
      console.error('Error', error);
    },
  }));

  
  updateAddressOnServer = createEffect(() => this.dataPersistence.fetch(AddressEntityActionTypes.UpdateAddressOnServer, {
    run: (action: UpdateAddressOnServer, state: any) => {
      return this.apiService
        .put<Address>(
          `v/1/associates/associates/${action.payload.address.associateId}/addresses/${action.payload.address.sequence}`,
          action.payload.address,
          { params: action.payload.queryParams }
        )
        .pipe(
          map((address) => {
            return new UpdateAddressOnServerSuccess(address);
          })
        );
    },
    onError: (action: UpdateAddressOnServer, error) => {
      console.error('Error', error);
    },
  }));

  
  createAddressOnServer = createEffect(() => this.dataPersistence.fetch(AddressEntityActionTypes.CreateAddressOnServer, {
    run: (action: CreateAddressOnServer, state: any) => {
      return this.apiService
        .post<Address>(`v/1/associates/associates/${action.payload.associateId}/addresses`, action.payload, {})
        .pipe(
          map((address) => {
            return new CreateAddressOnServerSuccess(address);
          })
        );
    },
    onError: (action: CreateAddressOnServer, error) => {
      console.error('Error', error);
    },
  }));

  constructor(private dataPersistence: DataPersistence<any>, private apiService: ApiService) {}
}
